import { FIELDS, PepperReview, SUBDOMAINS } from 'modules/cm/domain/PepperUploadPreview/PepperUploadPreview';

const data: PepperReview = {
  [SUBDOMAINS.GENERAL]: {
    [FIELDS.CASE_ID]: null,
    [FIELDS.ORIGINATION_ID]: null,
    [FIELDS.NUMBER_OF_APPLICANTS]: null,
    [FIELDS.ACCOUNT_NUMBER]: null,
    [FIELDS.SORT_CODE]: null,
  },
  [SUBDOMAINS.MORTGAGE_PROPERTY]: {
    [FIELDS.TITLE_NUMBER]: null,
    [FIELDS.FLAT_NUMBER]: null,
    [FIELDS.BUILDING_NAME]: null,
    [FIELDS.BUILDING_NUMBER]: null,
    [FIELDS.STREET]: null,
    [FIELDS.CITY]: null,
    [FIELDS.PROPERTY_POST_CODE]: null,
    [FIELDS.PROPERTY_TYPE]: null,
    [FIELDS.TENURE]: null,
    [FIELDS.PROPERTY_BUILT_YEAR]: null,
    [FIELDS.ACTUAL_PROPERTY_VALUE]: null,
    [FIELDS.INSPECTION_DATE]: null,
  },
  [SUBDOMAINS.LOAN]: {
    [FIELDS.PEPPER_PURPOSE_OF_THE_LOAN]: null,
    [FIELDS.FCA_LOAN_PURPOSE]: null,
    [FIELDS.NET_LOAN]: null,
    [FIELDS.IS_BUY_TO_LET]: null,
    [FIELDS.IS_MARGIN_ACTIVE]: null,
    [FIELDS.IS_APP_ACTIVE]: null,
    [FIELDS.PRODUCT_FEE]: null,
    [FIELDS.PRODUCT_FEE_PAYMENT]: null,
    [FIELDS.COMPLETION_DATE]: null,
    [FIELDS.VARIABLE_TERM_START_DATE]: null,
    [FIELDS.NUMBER_OF_PAYMENTS]: null,
    [FIELDS.FIXED_INTEREST_RATE]: null,
    [FIELDS.REVERT_MARGIN]: null,
    [FIELDS.LVR]: null,
  },
  [SUBDOMAINS.BORROWER]: {
    [FIELDS.APPLICANT_1]: {
      [FIELDS.BORROWER_TITLE]: null,
      [FIELDS.BORROWER_LAST_NAME]: null,
      [FIELDS.BORROWER_FIRST_NAME]: null,
      [FIELDS.BORROWER_GENDER]: null,
      [FIELDS.BORROWER_DATE_OF_BIRTH]: null,
      [FIELDS.BORROWER_PHONE_HOME]: null,
      [FIELDS.BORROWER_PHONE_MOBILE]: null,
      [FIELDS.BORROWER_PHONE_WORK]: null,
      [FIELDS.BORROWER_EMAIL]: null,
      [FIELDS.BORROWER_ADDITIONAL_EMAIL]: null,
      [FIELDS.BORROWER_EMPLOYMENT_STATUS]: null,
      [FIELDS.BORROWER_TOTAL_CURRENT_INCOME]: null,
    },
    [FIELDS.APPLICANT_2]: null,
  },
};

export default data;
